import { useRef } from "react";
import style from "./AppSearchPage.module.scss";
import { useSelector } from "react-redux";
import { selectSuggestions } from "../../../features/enhancedSearch";
import SearchResults from "../HeadSearch/SearchResults";
import classNames from "classnames";
import AppSearchRecentAndSaveTab from "./AppSearchRecentAndSaveTab";
import { saveRecentSearches } from "../../../features/enhancedSearch/recentSearchService";

export const AppSearchTabs = ({ push, searchValue }) => {
  const dropdownMobileRef = useRef(null);
  const suggestionsSelector = useSelector(selectSuggestions);
  const showSuggestion = searchValue.trim().length >= 3;
  const suggestionItemClick = (item) => {
    try {
      saveRecentSearches("combinedSearch", {
        searchText: item.suggestion,
        url: item.url,
        title: item.title,
      });
      push(item.url);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div
      className={classNames("size-14", style.searchLinks)}
      data-testid="search-tabs-page"
    >
      {showSuggestion ? (
        <div className={style.searchSuggestions}>
          <SearchResults
            ref={dropdownMobileRef}
            items={suggestionsSelector}
            handleSelect={suggestionItemClick}
            type="search"
            resultStyle={style}
            showSuggestion={showSuggestion}
          />
        </div>
      ) : (
        <AppSearchRecentAndSaveTab />
      )}
    </div>
  );
};
